export default __webpack_public_path__ + "static/media/logo.1c767b7f.png";